import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { MutationComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'
import { v2WorkHolidayDateKeys } from './use-v2-workholiday-find-date-query'

type CreateWorkHolidayBody = Parameters<typeof apiClient.v2.apiV2WorkholidayElCreate>[0]

const createWorkHoliday = async (body: CreateWorkHolidayBody) => {
  console.log(11)
  const { data } = await apiClient.v2.apiV2WorkholidayElCreate(body)
  return checkApiResponse(data)
}

export const useV2WorkHolidayCreateMutation = ({ options }: MutationComposableParams<unknown, CreateWorkHolidayBody> = {}) => {
  const queryClient = useQueryClient()
  return useMutation(() => {
    const resolved = resolveMaybeGetter(options ?? {})
    return {
      mutationFn: createWorkHoliday,
      ...resolved,
      // 저장 성공 시 도메인 캐시를 무효화한다 — 다음 조회가 fresh 데이터를 가져온다
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries({ queryKey: v2WorkHolidayDateKeys.all })
        return (resolved as { onSuccess?: (...args: unknown[]) => unknown }).onSuccess?.(data, variables, context)
      },
    }
  })
}
